module.exports = __webpack_public_path__ + "static/media/story-2.623226f0.jpeg";